module.exports = __webpack_public_path__ + "img/AB_Avellaneda.f063aca7.jpg";